import { render } from "./manage-field.vue?vue&type=template&id=06b2b1da"
import script from "./manage-field.vue?vue&type=script&lang=js"
export * from "./manage-field.vue?vue&type=script&lang=js"

import "./manage-field.vue?vue&type=style&index=0&id=06b2b1da&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__